import { createContext } from 'react';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const RestAppContext = createContext();

export default RestAppContext;

export const { Provider, Consumer } = RestAppContext;
